module.exports = __webpack_public_path__ + "img/MENU_DEPARTAMENTOS_ICONE_COM_TEXTO.050ad030.png";